<script>
  import {
    y,
    showLabelPage,
    posBeforeLabel,
    calledFromLabel,
    showSpecimenPage,
  } from '../stores.js'
  import { onMount } from 'svelte'
  export let img
  export let specimen = false
  export let name

  let element
  let draggableLabel
  onMount(() => {
    if (specimen == false) {
      draggableLabel = Draggable.create(element, {
        type: 'x,y',
        overshootTolerance: 0,
        bounds: 'body',
        onClick: handleClick,
        cursor: 'pointer',
        activeCursor: 'grabbing',
      })
    }
    return () => {
      if (typeof draggableLabel !== 'undefined') {
        draggableLabel[0].kill()
      }
    }
  })

  function handleClick() {
    posBeforeLabel.set($y)
    calledFromLabel.set(name)
    if (!specimen) {
      showLabelPage.set(true)
    } else {
      showSpecimenPage.set(true)
    }
  }
</script>

<img
  on:click={() => {
    if (specimen) {
      handleClick()
    }
  }}
  src={img}
  alt={specimen ? 'Arteria specimen' : 'Arteria Hotel Sign'}
  class:specimen
  bind:this={element} />

<style lang="scss">
  .specimen {
    transition: transform 0.2s;
    &:hover {
      cursor: pointer;
      transform: rotate(2deg);
    }
  }
</style>
